import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFlag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 80 80"
    {...props}
  >
    <rect width={80} height={80} fill="#1E6CE1" rx={40} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3}
      d="M44.222 29.444h12.059c.894 0 1.342 0 1.603.188a1 1 0 0 1 .41.696c.037.32-.18.711-.615 1.493l-2.939 5.29c-.157.284-.236.426-.267.576a1 1 0 0 0 0 .403c.031.15.11.292.267.576l2.94 5.29c.434.782.651 1.173.614 1.493a1 1 0 0 1-.41.696c-.261.188-.709.188-1.603.188H41.089c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V37.89M30.5 59l-8.444-33.777m3.166 12.666h15.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874c.218-.428.218-.988.218-2.108V24.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C42.702 21 42.142 21 41.022 21H25.098c-1.397 0-2.095 0-2.573.29a2 2 0 0 0-.874 1.12c-.165.533.004 1.21.343 2.566z"
    />
  </svg>
);
export default SvgFlag;
